module.exports = ".current-user{padding-right:10px;color:white;cursor:default}\n"